
export type CreateTweetWithMediaBody = {
  /** JSON stringified ComposerPayload */
  jsonData: string;
  /** Media files to upload (optional) */
  mediaFiles?: Blob[];
};
